import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Menu from "pages/menuMain/menu";
import _ from "lodash";
import ModalContext from "contexts/ModalContext";
import { Image, Button } from "antd";
import loadingKoala from "../../assets/imgage/wordBook/Animate-Loading-page.gif";
import cookie from "../../assets/imgage/wordBook/koala-biscuit.png";
import FlavorEvent from "pages/centerComponent/FlavorEvent";
import moment from "moment";
import ModalLuckyWord from "./ModalLuckyWord";
import GetCurrentPoint from "pages/profile/GetCurrentPoint";
import { GetCustomerData } from "services/Api/Module/Customer";
import { setProfile } from "features/ProfileSlice";

const RandomWord = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false); // ปุ่มกด
  const [isLoading, setIsLoading] = useState(true);

  // profile state กลาง
  const stateProfile = useSelector((state) => state.profile.dataUser);
  const customerId = stateProfile.id;
  const normalWord = stateProfile.wordBookNormalWord;
  const luckyWord = stateProfile.wordBookLuckyWord;
  // const normalWord = [
  //     {
  //         "id": "256",
  //         "name": "ฺB",
  //         "code": "002",
  //         "rate": "1",
  //         "img": "https://koalam-axelor-dev.scapp.work/365-2025/color/Asset%202.png"
  //     },
  //     {
  //         "id": "263",
  //         "name": "Doremi",
  //         "code": "102",
  //         "rate": "2",
  //         "img": "https://koalam-axelor-dev.scapp.work/365-2025/color/Asset%20102.png"
  //     },
  //     {
  //         "id": "257",
  //         "name": "C",
  //         "code": "003",
  //         "rate": "1",
  //         "img": "https://koalam-axelor-dev.scapp.work/365-2025/color/Asset%203.png"
  //     },
  //     {
  //         "id": "255",
  //         "name": "A",
  //         "code": "001",
  //         "rate": "1",
  //         "img": "https://koalam-axelor-dev.scapp.work/365-2025/color/Asset%201.png"
  //     },
  //     {
  //         "id": "256",
  //         "name": "ฺB",
  //         "code": "002",
  //         "rate": "1",
  //         "img": "https://koalam-axelor-dev.scapp.work/365-2025/color/Asset%202.png"
  //     },
  //     {
  //         "id": "260",
  //         "name": "F",
  //         "code": "006",
  //         "rate": "1",
  //         "img": "https://koalam-axelor-dev.scapp.work/365-2025/color/Asset%206.png"
  //     },
  //     {
  //         "id": "256",
  //         "name": "ฺB",
  //         "code": "002",
  //         "rate": "1",
  //         "img": "https://koalam-axelor-dev.scapp.work/365-2025/color/Asset%202.png"
  //     },
  //     {
  //         "id": "255",
  //         "name": "A",
  //         "code": "001",
  //         "rate": "1",
  //         "img": "https://koalam-axelor-dev.scapp.work/365-2025/color/Asset%201.png"
  //     },
  //     {
  //         "id": "260",
  //         "name": "F",
  //         "code": "006",
  //         "rate": "1",
  //         "img": "https://koalam-axelor-dev.scapp.work/365-2025/color/Asset%206.png"
  //     }
  // ]

  // const luckyWord = [
  //     {
  //         "id": "269",
  //         "name": "nine lucky 2",
  //         "code": "222",
  //         "rate": "3",
  //         "img": "https://koalam-axelor-dev.scapp.work/365-2025/color/Asset%20222.png"
  //     }
  // ]

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
      if (luckyWord.length > 0) {
        setOpenModal(true);
      }
    }, 5000);
  }, []);

  useEffect(() => {
    (async () => {
      if (stateProfile.id) {
        // const cusId = /*stateProfile.customerId*/10100;
        const cusId = stateProfile.id;
        const custormerProfile = await fetchCustomerProfile(cusId);
        dispatch(
          setProfile({
            ...custormerProfile.result,
            customerId: custormerProfile.result.id,
          }),
        );
      }
    })();
  }, []);

  const fetchCustomerProfile = async (id) => {
    let _return = {
      status: false,
      result: null,
    };

    try {
      const { data } = await GetCustomerData({ id: id });

      if (data.resultCode === "20000") {
        const resData = data.resultData;
        _return.status = true;
        _return.result = resData;
      } else {
        let _title = "เกิดข้อผิดพลาด",
          _subTitle = "กรุณาลองใหม่อีกครั้ง";
        mAlert.info({
          open: true,
          title: _title,
          subTitle: _subTitle,
          content: "",
          onExit: () => {},
        });
      }
    } catch (e) {
      console.log("ERR :", e);
    }
    return _return;
  };

  return (
    <div>
      <GetCurrentPoint />
      <Helmet>
        <title>โคอะลา มาร์ช</title>
        <meta name="title" content="โคอะลา มาร์ช" />
        <meta name="description" content="" />
        <meta name="keyword" content="" />
        <meta property="og:title" content="โคอะลา มาร์ช" />
        <meta property="og:description" content="" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="" />
      </Helmet>

      <div id="pageRandom">
        <main>
          <div className="wrapContent">
            {isLoading ? (
              <>
                <div className="pLoading">
                  <p>เรากำลังสุ่ม Wordbook </p>
                  <p>กรุณารอสักครู่...</p>
                  <Image preview={false} src={loadingKoala}>
                    {" "}
                  </Image>
                </div>
              </>
            ) : (
              <>
                <section id="pProfileMain">
                  <div className="bProfile">
                    <p>Koala’s March point ของคุณ</p>
                    <div className="bTotalPoint">
                      <span>{stateProfile.currentPoint}</span>
                    </div>
                  </div>
                  <p className="bExpire">
                    หมดอายุ 31 ธันวาคม {Number(moment().format("YYYY")) + 543}
                  </p>
                  <div className="bPoint">
                    <FlavorEvent
                      currentPoint={stateProfile.currentPoint}
                      point={stateProfile.point}
                    />
                  </div>
                  <div className="bPointBg">
                    <div className="bLink">
                      <a onClick={() => navigate("/history-collect-point")}>
                        ประวัติการ Collect point
                      </a>
                    </div>
                  </div>
                </section>
                <div className="pDetails">
                  <div className="koalaWord">
                    <p>
                      คุณได้รับ Wordbook รวมทั้งหมด{" "}
                      {normalWord?.length + luckyWord?.length} ตัว
                    </p>
                    {luckyWord.length > 0 && (
                      <>
                        <h2>Lucky Word</h2>
                        <div className="pClover">
                          <Image preview={false} src={luckyWord[0].img}></Image>
                        </div>
                      </>
                    )}
                    <div className="pBiscuits">
                      {normalWord &&
                        normalWord.map((item, index) => {
                          return <Image preview={false} src={item.img}></Image>;
                        })}
                    </div>
                  </div>
                  <div className="pBtn">
                    <Button
                      className="btn1"
                      onClick={() => navigate("/word-book-main")}
                    ></Button>
                    <Button
                      className="btn2"
                      onClick={() => navigate("/scanpoint")}
                    >
                      กรอกโค้ดเพิ่ม
                    </Button>
                    <Button
                      className="btn3"
                      onClick={() => navigate("/word-book-all")}
                    >
                      หน้า Wordbook
                    </Button>
                  </div>
                </div>
              </>
            )}
          </div>
        </main>
        <Menu />
      </div>

      {luckyWord.length > 0 && (
        <ModalLuckyWord
          isOpen={openModal}
          luckyImg={luckyWord[0].img}
          onClose={() => setOpenModal(false)}
        />
      )}
    </div>
  );
};

export default RandomWord;
